import React, { useEffect, useState } from "react";
import { getAllCollegePagination } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { createCollegeRanking } from "../../Services/CollegeService";

const AddCollegeRanking = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: "",
        college_id: "", 
        ranking_given_by: "", 
        ranking_from: "",
        ranking_to: "",
    });
    const [loader, setLoader] = useState(false);
    const [college, setCollege] = useState([]);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createCollegeRanking(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getAllCollegeCall = async () => {
        let { ok, data } = await getAllCollegePagination({});
        if (ok) {
            setCollege(data?.records);
        }
    };

    useEffect(() => {
        getAllCollegeCall();
        if (data?.data) {
            const { id, college_id, ranking_given_by, ranking_from, ranking_to } = data?.data;
            setReqData({ id, college_id, ranking_given_by, ranking_from, ranking_to })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add College Ranking" : "Edit College Ranking"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Ranking Given By</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Ranking Given By"
                                                required
                                                value={reqData?.ranking_given_by}
                                                onChange={(e) => handleChange("ranking_given_by", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Ranking From</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Ranking From"
                                                required
                                                value={reqData?.ranking_from}
                                                onChange={(e) => handleChange("ranking_from", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Ranking To</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Ranking To"
                                                required
                                                value={reqData?.ranking_to}
                                                onChange={(e) => handleChange("ranking_to", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>College</label>
                                            <select required value={reqData?.college_id} onChange={(e) => handleChange("college_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select College</option>
                                                {college?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddCollegeRanking;